// extracted by mini-css-extract-plugin
export default {"header":"ytVD6vW_GVJfisLpyyWA","title":"zZN4c2h61eS2vTlN43uQ"};